import account from './interfaces/account'
import passport from './interfaces/passport'
import unifydata from './interfaces/unifydata'

export default {
  account,
  passport,
  unifydata
}